export default __webpack_public_path__ + "static/753-0dc52ab778a6a039b2cf37c1478b0265.gif";